<div class="al-dialog">
  <!-- Header -->
  <div class="al-header">
    <div class="al-header-left">
      <mat-icon class="al-header-icon">place</mat-icon>
      <span class="al-header-title">{{ 'customers.add_location.title' | translate }}</span>
    </div>
    <button class="al-close-btn" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <div class="al-body" [formGroup]="form">
    <!-- Location Information -->
    <div class="al-section">
      <p class="al-section-title">{{ 'customers.add_location.section_title' | translate }}</p>

      <div class="al-field">
        <label class="al-label">{{ 'common.location_name' | translate }}</label>
        <input class="al-input" type="text" formControlName="name" [placeholder]="'customers.add_location.name_placeholder' | translate">
        <span class="al-error" *ngIf="form.get('name')?.touched && form.get('name')?.errors">
          {{ "common.required_field" | translate }}
        </span>
      </div>

      <div class="al-row-2col">
        <div class="al-field al-field-vat">
          <label class="al-label">{{ 'customers.add_location.vat_code' | translate }} <span class="al-optional">({{ 'common.optional' | translate }})</span></label>
          <input class="al-input" type="text" formControlName="tax_id" [placeholder]="'customers.add_location.vat_code_placeholder' | translate">
          <span class="al-error" *ngIf="form.get('tax_id')?.touched && form.get('tax_id')?.hasError('maxlength')">
            {{ 'customers.add_location.max_64_chars' | translate }}
          </span>
        </div>
        <div class="al-field al-field-erp">
          <label class="al-label">{{ 'customers.details.erp_id' | translate }} <span class="al-optional">({{ 'common.optional' | translate }})</span></label>
          <input class="al-input" type="text" formControlName="erp_id" [placeholder]="'customers.add_location.erp_id_placeholder' | translate">
          <span class="al-error" *ngIf="form.get('erp_id')?.touched && form.get('erp_id')?.hasError('maxlength')">
            {{ 'customers.add_location.max_64_chars' | translate }}
          </span>
        </div>
      </div>

      <div class="al-row-2col">
        <div class="al-field al-field-address">
          <label class="al-label">{{ 'companies.shipping_address' | translate }}</label>
          <input class="al-input" type="text" formControlName="apartment" id="loc-apartment"
                 [placeholder]="'customers.add_location.address_placeholder' | translate" autocomplete="off">
        </div>
        <!-- Billing address input is hidden when "same as shipping" is checked; its value is still written
             by toggleBillingAddress() so the submit payload remains consistent. -->
        <div class="al-field al-field-address" *ngIf="!form.get('is_bill_same')?.value">
          <label class="al-label">{{ 'companies.billing_address' | translate }}</label>
          <input class="al-input" type="text" formControlName="billing_apartment" id="loc-billing-apartment"
                 [placeholder]="'customers.add_location.address_placeholder' | translate" autocomplete="off">
        </div>
      </div>

      <div class="al-checkbox-row">
        <mat-checkbox style="width: auto !important;" formControlName="is_bill_same" (change)="toggleBillingAddress()">
          {{ 'customers.add_location.billing_same_as_shipping' | translate }}
        </mat-checkbox>
      </div>

      <div class="al-row-2col">
        <div class="al-field al-field-currency">
          <label class="al-label">{{ 'companies.currency' | translate }}</label>
          <select class="al-select" formControlName="currency">
            <option value="">{{ 'common.select' | translate }}</option>
            <option *ngFor="let c of data.currencies" [value]="c.id">
              {{ c.name }} ({{ c.symbol }})
            </option>
          </select>
        </div>
        <div class="al-field al-field-payment">
          <label class="al-label">{{ 'companies.payment_terms' | translate }}</label>
          <select class="al-select" formControlName="payment_terms">
            <option value="">{{ 'common.select' | translate }}</option>
            <option *ngFor="let t of data.paymentTerms" [value]="t.id">
              {{ t.name | translate }}
            </option>
          </select>
        </div>
      </div>

      <!-- Main Location Toggle Card -->
      <div class="al-toggle-card">
        <div class="al-toggle-text">
          <span class="al-toggle-title">{{ 'customers.add_location.is_main_title' | translate }}</span>
          <span class="al-toggle-subtitle">{{ 'customers.add_location.is_main_subtitle' | translate }}</span>
        </div>
        <mat-slide-toggle formControlName="is_main"
          (change)="onMainToggleChange($event)">
        </mat-slide-toggle>
      </div>
    </div>

    <!-- Main Contact Section: hidden when traditional contacts are off (WB-7369) -->
    <div class="al-section" *ngIf="featureFlagService.traditionalContactsEnabled">
      <p class="al-section-title">{{ 'customers.details.main_contact_label' | translate }} <span class="al-optional">({{ 'common.optional' | translate }})</span></p>
      <div class="al-contact-row">
        <!-- Contact selector is only shown in edit mode because create mode has no existing contacts to choose from yet.
             New contacts can always be created via the button below regardless of mode. -->
        <div class="al-field al-field-contact" *ngIf="isEditMode">
          <label class="al-label">{{ 'customers.add_location.select_contact' | translate }}</label>
          <select class="al-select" [value]="selectedContactEmail" (change)="onContactSelected($event)">
            <option value="">{{ 'common.select' | translate }}</option>
            <option *ngFor="let c of availableContacts" [value]="c.email">
              {{ c.contact_fname }} {{ c.contact_lname }}
            </option>
          </select>
        </div>
        <button class="al-create-contact-btn" type="button" (click)="createContact()">{{ 'customers.add_location.create_contact' | translate }}</button>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="al-footer">
    <button class="al-btn-cancel" (click)="cancel()">{{ 'common.CANCEL' | translate }}</button>
    <button class="al-btn-proceed" (click)="proceed()">
      <span>{{ 'customers.add_location.proceed' | translate }}</span>
      <mat-icon class="al-btn-icon">arrow_forward</mat-icon>
    </button>
  </div>
</div>
